<template>
  <div class="form-background pb-100 pt-100 mb-pt-60 mb-pb-60 mb-pl-20 mb-pr-20">
    <div class="form-wrapper bg-white wp-100 maxw-610 pb-24" style="margin: auto;">
      <h2 class="fs-28 lh-36 black fw-700 tc mb-fs-28 mb-lh-28 form-title py-20">
        <slot name="title"></slot>
      </h2>
      <div class='pt-24 px-24'>
        <slot name="form"></slot>
      </div>
    </div>
    <slot name="error"></slot>
  </div>
</template>

<style scoped lang="scss">
.form-background {
  background: url('https://s3-cdn.designerjourneys.com/static/images/user/bg-form.jpg');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  .form-wrapper{
    //box-shadow: 0px 4px 44px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    border: 1px solid brandColor(gray, 300)
  }
  .form-title {border-bottom: 1px solid brandColor(gray, 300)}
}
</style>
<script setup>
</script>
